import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import { memo, Ref } from 'react';

export interface TabPanelProps extends Omit<
  ComponentPropsWithoutRef<'div'>,
  'title'
> {
  title: string;
  children: ReactNode;
  id?: string;
  disabled?: boolean;
  ref?: Ref<HTMLDivElement>;
}

interface InternalTabPanelProps {
  __selected?: boolean;
  __controlsId?: string;
  __index?: number;
}

export const TabPanel = memo(
  ({
    children,
    __selected,
    __controlsId,
    id,
    title,
    className,
    style,
    ref,
    disabled,
    ...rest
  }: TabPanelProps & InternalTabPanelProps) => (
    <div
      ref={ref}
      role="tabpanel"
      id={__controlsId}
      aria-labelledby={id}
      hidden={!__selected}
      tabIndex={__selected ? 0 : -1}
      className={className}
      style={{
        display: __selected ? 'block' : 'none',
        ...style,
      }}
      {...rest}
    >
      {children}
    </div>
  ),
);
